import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints";

const ViewNetwork = () => {
  const [networkData, setNetworkData] = useState();
  const { netid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getNetworkData = async () => {
      try {
        const response = await axios.get(API.GET_NETWORK_BYID(netid));
        console.log("Response Data:", response.data);
        
        if (response.data) {
          setNetworkData(response.data);  // Directly set the object
        } else {
          setNetworkData(null);
        }
      } catch (error) {
        console.error("Error fetching network data:", error);
        setNetworkData(null); // Handle fetch errors
      }
    };
  
    if (netid) getNetworkData();
  }, [netid]);
   
  

  const deleteNetwork = async (netid) => {
    try {
      await axios.delete(API.DELETE_NETWORK_API(netid));
      alert("Network deleted successfully");
      navigate("/networktable");
    } catch (error) {
      alert("Failed to delete network");
      console.error("Error deleting network:", error.response ? error.response.data : error.message);
    }
  };

  const goBack = () => {
    navigate("/networktable");
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {networkData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Network Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Subscription Name</span>
                      <span>{networkData.subname}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Subscription Type</span>
                      <span>{networkData.subtype}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Currency</span>
                      <span>{networkData.currency}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Description</span>
                      <span>{networkData.description}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Level 1</span>
                      <span>{networkData.level1}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Level 2</span>
                      <span>{networkData.level2}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Level 3</span>
                      <span>{networkData.level3}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Level 4</span>
                      <span>{networkData.level4}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded"
                      onClick={() => deleteNetwork(networkData.netid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading network details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewNetwork;
